import { render, staticRenderFns } from "./Dump.vue?vue&type=template&id=672877f6&scoped=true"
import script from "./Dump.vue?vue&type=script&setup=true&lang=js"
export * from "./Dump.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Dump.vue?vue&type=style&index=0&id=672877f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672877f6",
  null
  
)

export default component.exports